import {API_BASE} from '../apiConfig';
import {AD_GOALS, trackAdGoal} from '../../analytics/adTracking';
import {sendPageEvent} from '../../analytics/gameAnalytics';
import {getDeviceKind} from '../device/getDeviceKind';

/**
 * Разовая награда за первый вход через установленное приложение: просит ее у
 * сервера и отправляет метрики. Первый ли это раз, решает сервер (флаг в
 * профиле) — клиент лишь сообщает, что запущен из приложения.
 *
 * Отсюда же уходит рекламная цель APP_FIRST_LAUNCH: сервер подтвердил, что
 * игрок действительно зашел из установленного приложения, и выдал награду
 * ровно один раз на аккаунт. На iOS это единственный сигнал установки —
 * события браузера appinstalled там не бывает (см. utils/pwa/appInstall).
 *
 * @param {Object} params
 * @param {string} params.userId — для привязки цели к пользователю
 * @returns {Promise<{granted: boolean, chestId: ?string, grantedAt: ?string}|null>}
 *          null — награду не выдали (уже получена, ошибка или отказ сервера)
 */
export const requestAppInstallReward = async ({userId} = {}) => {
  try {
    const res = await fetch(`${API_BASE}/users/me/app-install-reward`, {
      method: 'POST',
      credentials: 'include',
      headers: {'Content-Type': 'application/json'},
      // Признак «зашел через установленное приложение» может прислать только
      // клиент — сервер его проверить не может и полагается на свой флаг
      // «награда уже выдана»
      body: JSON.stringify({isInstalledApp: true}),
    });
    const data = res.ok ? await res.json() : null;

    if (!data?.granted) {
      sendPageEvent('MainMenu', 'app_install_reward', data ? 'already' : 'error');
      return null;
    }

    sendPageEvent('MainMenu', 'app_install_reward', 'granted', getDeviceKind());
    trackAdGoal(AD_GOALS.APP_FIRST_LAUNCH, {userId, params: {device: getDeviceKind()}});
    return data;
  } catch (error) {
    console.error('App install reward error', error);
    sendPageEvent('MainMenu', 'app_install_reward', 'error');
    return null;
  }
};
